import React from 'react';
import { Link } from 'react-router-dom';
import styles from './AdminBreadcrumb.module.css';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface AdminBreadcrumbProps {
  items: BreadcrumbItem[];
  separator?: string;
  className?: string;
}

export const AdminBreadcrumb: React.FC<AdminBreadcrumbProps> = ({
  items,
  separator = '/',
  className = '',
}) => {
  if (items.length === 0) return null;

  return (
    <nav
      aria-label="Breadcrumb"
      className={`${styles.breadcrumb} ${className}`}
    >
      <ol className={styles.list}>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const isFirst = index === 0;

          return (
            <li key={index} className={styles.item}>
              {item.href && !isLast ? (
                <Link to={item.href} className={styles.link}>
                  <span
                    className={`${styles.label} ${isFirst ? '' : styles.hiddenMobile}`}
                  >
                    {item.label}
                  </span>
                </Link>
              ) : (
                <span
                  className={`${styles.label} ${styles.current} ${
                    !isLast ? styles.hiddenMobile : ''
                  }`}
                  aria-current={isLast ? 'page' : undefined}
                >
                  {item.label}
                </span>
              )}
              {!isLast && (
                <span className={styles.separator} aria-hidden="true">
                  {separator}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
